import { render, staticRenderFns } from "./itemAttributChild.vue?vue&type=template&id=77f2a8a8&scoped=true&"
import script from "./itemAttributChild.vue?vue&type=script&lang=js&"
export * from "./itemAttributChild.vue?vue&type=script&lang=js&"
import style0 from "./itemAttributChild.vue?vue&type=style&index=0&id=77f2a8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f2a8a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCardText,VRadio,VRadioGroup,VSelect})
